(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('policyRuleConfig', ["policyRuleModes", "feature", "modulesManager", function (policyRuleModes, feature, modulesManager) {
        var saasConfigs = {
            office365_emails: {
                type: 'email',
                identityTypes: { users: 'office365_emails_user' }
            },
            office365_onedrive: {
                type: 'drive',
                identityTypes: { users: 'office365_emails_user' }
            },
            google_mail: {
                type: 'email',
                identityTypes: {
                    users: 'google_user',
                    groups: 'google_group'
                }
            },
            google_drive: {
                type: 'drive',
                identityTypes: {
                    users: 'google_user',
                    groups: 'google_group'
                }
            }
        };
        var ruleTypes = [
            {
                id: 'dlp',
                label: 'DLP',
                saasTypes: {
                    drive: true,
                    email: true
                },
                backendType: 'dlp',
                sec_types: ['dlp'],
                alwaysOnSecTypes: { 'dlp': true }
            },
            {
                id: 'av',
                label: 'Malware',
                saasTypes: { drive: true },
                backendType: 'malware',
                sec_types: ['av'],
                appSelector: true,
                overwrite: {
                    ms_teams: {
                        label: 'Threat Detection',
                        sec_types: [
                            'av',
                            'ap'
                        ],
                        alwaysAvailableSecTypes: { 'ap': true },
                        availableApps: { ap: ['checkpoint_url'] }
                    },
                    slack: {
                        label: 'Threat Detection',
                        sec_types: [
                            'av',
                            'ap'
                        ],
                        alwaysAvailableSecTypes: { 'ap': true },
                        availableApps: { ap: ['checkpoint_url'] }
                    }
                }
            },
            {
                id: 'av_ap',
                label: 'Threat Detection',
                saasTypes: { email: true },
                backendType: 'malware',
                workflows: true,
                sec_types: [
                    'av',
                    'ap'
                ],
                appSelector: true,
                inlineApp: function (config) {
                    return config && config.inline_configurator && config.inline_configurator.inline_app;
                }
            },
            {
                id: 'anomaly',
                label: 'Anomaly Detection',
                saasTypes: {
                    drive: true,
                    email: true
                },
                disableIdentities: true,
                sec_types: ['anomaly'],
                alwaysOnSecTypes: { 'anomaly': true },
                alwaysAvailableSecTypes: { 'anomaly': true },
                backendType: 'anomaly',
                hidden: !feature.showAnomaly
            },
            {
                id: 'custom',
                label: 'Custom Query',
                saasTypes: {
                    drive: true,
                    email: true
                }
            },
            {
                id: 'access_control',
                label: 'Cloud Access Control',
                saasTypes: {
                    drive: true,
                    email: true
                },
                sec_types: ['access_control'],
                alwaysOnSecTypes: { 'access_control': true },
                alwaysAvailableSecTypes: { 'access_control': true },
                backendType: 'access_control',
                hidden: !feature.showAccessControlRules
            },
            {
                id: 'clicktime_protection',
                label: 'ClickTime Protection',
                saasTypes: { email: true },
                backendType: 'clicktime_protection',
                sec_types: ['clicktime_protection'],
                alwaysOnSecTypes: { 'clicktime_protection': true },
                hidden: !feature.showClicktimeProtection
            }
        ];
        if (feature.lastlineTheme) {
            ruleTypes.splice(0, 1);
        }
        var identityIcon = function (item) {
            var result = '';
            if (item.type === 'users') {
                result = '#' + JSON.stringify({
                    display: 'text',
                    class: 'icomoon icomoon-user item-text-icon'
                });
            } else if (item.type === 'groups') {
                result = '#' + JSON.stringify({
                    display: 'text',
                    class: 'icomoon icomoon-users-group item-text-icon'
                });
            }
            return result;
        };
        var workflows = [
            {
                id: 'threat_extraction_mode',
                label: 'TEX mode',
                listLabel: 'Tex',
                variants: [
                    {
                        id: false,
                        label: 'Disable',
                        default: true
                    },
                    {
                        id: true,
                        label: 'Enable'
                    }
                ],
                moduleName: 'cp_threat_extraction',
                secType: 'av',
                ruleTypes: ['av_ap']
            },
            {
                id: 'threat_extraction_types_clean',
                label: 'Clean',
                listLabel: 'Tex',
                variants: [
                    {
                        id: 'none',
                        label: 'None'
                    },
                    {
                        id: 'all',
                        label: 'All file types',
                        default: true
                    },
                    {
                        id: 'all_except',
                        label: 'All file types except'
                    },
                    {
                        id: 'only',
                        label: 'Only'
                    }
                ],
                moduleName: 'cp_threat_extraction',
                secType: 'av',
                ruleTypes: ['av_ap']
            },
            {
                id: 'threat_extraction_types_convert',
                label: 'Convert',
                listLabel: 'Tex',
                variants: [
                    {
                        id: 'none',
                        label: 'None',
                        default: true
                    },
                    {
                        id: 'all',
                        label: 'All file types'
                    },
                    {
                        id: 'all_except',
                        label: 'All file types except'
                    },
                    {
                        id: 'only',
                        label: 'Only'
                    }
                ],
                moduleName: 'cp_threat_extraction',
                secType: 'av',
                ruleTypes: ['av_ap']
            },
            {
                id: 'threat_extraction_workflow',
                label: 'TEX workflow',
                listLabel: 'Tex',
                variants: [
                    {
                        id: 'admin_approve',
                        label: 'User is allowed to restore any attachment (admin must approve)',
                        default: true
                    },
                    {
                        id: 'user_benign',
                        label: 'User allowed to restore benign attachments only'
                    },
                    {
                        id: 'user_all',
                        label: 'User is allowed to restore any attachment'
                    }
                ],
                moduleName: 'cp_threat_extraction',
                secType: 'av',
                ruleTypes: ['av_ap']
            },
            {
                id: 'approve_restoration',
                label: 'Malicious attachment workflow',
                listLabel: 'Malicious',
                variants: [
                    {
                        id: 'user',
                        label: 'User is alerted and allowed to restore the email',
                        default: true
                    },
                    {
                        id: 'admin',
                        label: 'User is alerted, allowed to request a restore (admin must approve)'
                    },
                    {
                        id: 'none',
                        label: 'Email removed. User is not alerted (admin can restore)'
                    }
                ],
                secType: 'av',
                ruleTypes: ['av_ap']
            },
            {
                id: 'approve_inline_dlp_restoration',
                label: 'DLP workflow',
                listLabel: 'DLP',
                variants: [
                    {
                        id: 'user',
                        label: 'User is alerted and allowed to restore the email',
                        default: true
                    },
                    {
                        id: 'admin',
                        label: 'User is alerted, allowed to request a restore (admin must approve)'
                    },
                    {
                        id: 'allow',
                        label: 'Email is allowed- allow email to go through as is'
                    }
                ],
                secType: 'dlp',
                ruleTypes: ['dlp']
            },
            {
                id: 'phishing_mode',
                label: 'Phishing workflow',
                listLabel: 'Anti-Phishing',
                variants: [
                    {
                        id: 'alert',
                        label: 'User receives the email with a warning email',
                        default: true
                    },
                    {
                        id: 'block',
                        label: 'User does not receive the email (admin can restore)'
                    }
                ],
                secType: 'ap',
                ruleTypes: ['av_ap']
            },
            {
                id: 'moderation_reject_mode',
                label: 'Leak workflow',
                listLabel: 'Leak',
                secType: 'dlp',
                ruleTypes: ['dlp']
            },
            {
                id: 'suspicious_phishing_mode',
                label: 'Suspicious phishing workflow',
                listLabel: 'Suspicious',
                advanced: true,
                variants: [
                    {
                        id: 'alert',
                        label: 'User receives the email with a warning email',
                        default: true
                    },
                    {
                        id: 'block',
                        label: 'User does not receive the email (admin can restore)'
                    }
                ],
                secType: 'ap',
                ruleTypes: ['av_ap']
            }
        ];
        if (feature.showSuspiciousMalwareWorkflow) {
            workflows.push({
                id: 'suspicious_malware_mode',
                label: 'Suspicious malware workflow',
                listLabel: 'Suspicious',
                advanced: true,
                variants: [
                    {
                        id: 'user',
                        label: 'User is alerted and allowed to restore the email'
                    },
                    {
                        id: 'admin',
                        label: 'User is alerted, allowed to request a restore (admin must approve)'
                    },
                    {
                        id: 'none',
                        label: 'Email removed. User is not alerted (admin can restore)'
                    },
                    {
                        id: 'allow',
                        label: 'Do nothing',
                        default: true
                    }
                ],
                secType: 'av',
                ruleTypes: [
                    'av_ap',
                    'av'
                ]
            });
        }
        if (feature.showSpam) {
            workflows.push({
                id: 'spam_workflow',
                label: 'Spam workflow',
                listLabel: 'Spam',
                secType: 'ap',
                ruleTypes: ['av_ap']
            });
        }
        if (!feature.checkpointTheme) {
            if (feature.showMarketing) {
                workflows.push({
                    id: 'marketing_workflow',
                    label: 'Marketing workflow',
                    listLabel: 'Marketing',
                    secType: 'ap',
                    ruleTypes: ['av_ap']
                });
            }
        }
        var ruleStates = [
            {
                autoId: 'policy_rule_edit_rule_state_dropdown_item_running',
                id: 'running',
                label: 'Running'
            },
            {
                autoId: 'policy_rule_edit_rule_state_dropdown_item_pause',
                id: 'pause',
                label: 'Stopped'
            }
        ];
        var inlineDlpBlacklist = ['google_mail'];
        var policyRuleConfig = {
            ruleTypes: function (newRuleTypes) {
                if (newRuleTypes) {
                    ruleTypes = angular.copy(newRuleTypes);
                }
                return ruleTypes;
            },
            ruleTypesMap: function () {
                return _(ruleTypes).chain().map(function (ruleType) {
                    return [
                        ruleType.id,
                        ruleType
                    ];
                }).object().value();
            },
            getSaasType: function (saas) {
                return saasConfigs[saas] && saasConfigs[saas].type || 'drive';
            },
            getSaasRuleTypes: function (saas, securityApps) {
                var availableSecTypes = _(securityApps).reduce(function (memo, app) {
                    if (app.sec_type) {
                        memo[app.sec_type] = true;
                        if (app.sec_type === 'clicktime_protection' && app.state !== 'active') {
                            memo[app.sec_type] = false;
                        }
                    }
                    return memo;
                }, {});
                var saasType = policyRuleConfig.getSaasType(saas);
                return _(ruleTypes).chain().map(function (type) {
                    if (type.hidden) {
                        return;
                    }
                    if (_(type.saasTypes[saasType]).isUndefined()) {
                        return;
                    }
                    if (feature.checkpointTheme && type.id === 'dlp' && _(securityApps).findIndex(function (app) {
                            return app.name === 'dlp_checkpoint2' && app.state === 'active';
                        }) !== -1) {
                        return;
                    }
                    var newType = {
                        autoId: 'policy_rule_create_rule_type_dropdown_item_' + type.id,
                        id: type.id,
                        label: type.label,
                        disabled: type.disabled || !type.saasTypes[saasType] || type.sec_types && _(type.sec_types).chain().find(function (secType) {
                            return type.alwaysAvailableSecTypes && type.alwaysAvailableSecTypes[secType] || availableSecTypes[secType];
                        }).isUndefined().value(),
                        tooltip: type.tooltip
                    };
                    if (type.overwrite && type.overwrite[saas] && type.overwrite[saas].label) {
                        newType.label = type.overwrite[saas].label;
                    }
                    return newType;
                }).compact().value();
            },
            ruleTypeConfig: function (saas, ruleTypeId, securityApps) {
                var availableSecTypes = _(securityApps).reduce(function (memo, app) {
                    if (app.sec_type) {
                        memo[app.sec_type] = true;
                    }
                    return memo;
                }, {});
                var config = angular.copy(policyRuleConfig.ruleTypesMap()[ruleTypeId]);
                config.activeSecTypes = {};
                if (config.sec_types) {
                    if (config.overwrite && config.overwrite[saas]) {
                        // overwrite
                        if (config.overwrite[saas].sec_types) {
                            config.sec_types = config.overwrite[saas].sec_types;
                        }
                        if (config.overwrite[saas].alwaysAvailableSecTypes) {
                            config.alwaysAvailableSecTypes = config.overwrite[saas].alwaysAvailableSecTypes;
                        }
                        if (config.overwrite[saas].label) {
                            config.label = config.overwrite[saas].label;
                        }
                    }
                    _(config.sec_types).each(function (secType) {
                        if (config.alwaysAvailableSecTypes && config.alwaysAvailableSecTypes[secType] || availableSecTypes[secType]) {
                            config.activeSecTypes[secType] = true;
                        }
                    });
                    if (_(config.activeSecTypes).isEmpty()) {
                        config.activeSecTypes = null;
                    }
                }
                var extendedModeData = policyRuleConfig.ruleModeExtended(saas, ruleTypeId);
                var saasApp = modulesManager.cloudApp(saas);
                config.modes = _(policyRuleModes.data).chain().map(function (info) {
                    if (info.id !== 'alert' && saasApp && saasApp.alert_only_rules) {
                        return;
                    }
                    if (!extendedModeData[info.id]) {
                        return;
                    }
                    if (extendedModeData[info.id].default) {
                        config.defaultMode = info.id;
                    }
                    var mode = $.extend({}, info);
                    if (extendedModeData[info.id].description) {
                        mode = $.extend(mode, {
                            tooltip: {
                                content: { text: extendedModeData[info.id].description },
                                position: {
                                    at: 'right center',
                                    my: 'left center'
                                },
                                style: {
                                    classes: 'rule-edit-qtip',
                                    tip: {
                                        width: 14,
                                        height: 8,
                                        corner: true
                                    }
                                }
                            }
                        });
                    }
                    return mode;
                }).compact().value();
                if (!config.defaultMode) {
                    config.defaultMode = config.modes[0].id;
                }
                config.workflows = _(workflows).filter(function (workflow) {
                    return _(workflow.ruleTypes).includes(ruleTypeId);
                });
                if (config.backendType === 'dlp' && policyRuleConfig.getSaasType(saas) === 'drive') {
                    config.showSkipInternal = 'Skip internal items';
                    if (saas === 'ms_teams') {
                        config.showSkipInternal = 'Skip internal conversations';
                    }
                }
                return config;
            },
            backendRuleType: function (ruleTypeId) {
                return policyRuleConfig.ruleTypesMap()[ruleTypeId].backendType;
            },
            localRuleType: function (saas, backendType) {
                var saasType = policyRuleConfig.getSaasType(saas);
                var ruleType = _(ruleTypes).find(function (type) {
                    return type.saasTypes[saasType] && type.backendType === backendType;
                });
                return ruleType && ruleType.id;
            },
            ruleStates: function () {
                return angular.copy(ruleStates);
            },
            identitiesToList: function (rule) {
                var scopes = [];
                var excludes = [];
                _(rule.identity).each(function (data, type) {
                    if (type === 'exclude' && !_(data).isEmpty()) {
                        _(data).each(function (excludeData, excludeType) {
                            _(excludeData.items).each(function (id, idx) {
                                var resolved = rule._resolved && rule._resolved.entities && rule._resolved.entities[excludeType] && rule._resolved.entities[excludeType][id];
                                if (!resolved || resolved.not_found) {
                                    return;
                                }
                                excludes.push($.extend(resolved, {
                                    type: excludeType,
                                    entity_id: id,
                                    entity_type: excludeData.type
                                }));
                            });
                        });
                    } else {
                        _(data.items).each(function (id, idx) {
                            var resolved = rule._resolved && rule._resolved.entities && rule._resolved.entities[type] && rule._resolved.entities[type][id];
                            if (!resolved || resolved.not_found) {
                                return;
                            }
                            resolved = $.extend(resolved, {
                                type: type,
                                entity_id: id,
                                entity_type: data.type
                            });
                            if (_(scopes).findIndex(function (scope) {
                                    return scope.entity_id === resolved.entity_id;
                                }) === -1) {
                                scopes.push(resolved);
                            }
                        });
                    }
                });
                return {
                    scopes: _(scopes).sortBy('order'),
                    excludes: _(excludes).sortBy('order')
                };
            },
            formatIdentity: function (item) {
                var identityClass = 'policy-rule-identity';
                var tooltipText = (item.gui_label || '') + ' ' + (item.gui_sub_label || '');
                if (item.redirect && !item.av_license_enabled) {
                    identityClass += ' no-license';
                    tooltipText = 'Unlicensed user. Click to go to license configuration screen';
                }
                var result = identityIcon(item) + '#' + JSON.stringify({
                    display: 'text',
                    text: (item.gui_label ? item.gui_label : item.gui_sub_label) || ' ',
                    tooltip: {
                        content: { text: tooltipText },
                        position: {
                            at: 'top center',
                            my: 'bottom center'
                        }
                    }
                });
                if (item.is_quarantine_user) {
                    result += '#' + JSON.stringify({
                        display: 'text',
                        class: 'icomoon icomoon-events item-text-icon warning',
                        tooltip: {
                            content: { text: 'Quarantine user should be a dedicated service user; enforcing policy in the quarantine user is currently not supported' },
                            position: {
                                at: 'top center',
                                my: 'bottom center'
                            }
                        }
                    });
                }
                return '#' + JSON.stringify({
                    display: 'linked-text',
                    'class': identityClass,
                    text: result
                });
            },
            identityUniqueId: function (item, idx) {
                return item.type + '-' + item.entity_id + idx.toString();
            },
            allDlpRules: function (dlpRules) {
                var selected = [];
                function processItems(items) {
                    _(items).each(function (item) {
                        if (item.id) {
                            selected.push(item.id);
                        }
                        if (item.items) {
                            processItems(item.items);
                        }
                    });
                }
                processItems(dlpRules);
                return selected;
            },
            workflows: function () {
                return angular.copy(workflows);
            },
            saasAllowedModes: function (saas) {
                var saasApp = modulesManager.cloudApp(saas);
                if (saasApp && saasApp.alert_only_rules) {
                    return { alert: true };
                }
                var modes = feature.showAccessControlRules ? { block: true } : {};
                if (policyRuleConfig.getSaasType(saas) === 'email') {
                    return $.extend({
                        inline: true,
                        normal: true,
                        alert: true
                    }, modes);
                } else {
                    return $.extend({
                        normal: true,
                        alert: true
                    }, modes);
                }
            },
            saasRuleModes: function (saas) {
                //this function lists all possible modes for all possible types to create filter in a list
                var allowedModes = policyRuleConfig.saasAllowedModes(saas);
                return policyRuleModes.data.filter(function (mode) {
                    return allowedModes[mode.id];
                });
            },
            ruleModeExtended: function (saas, ruleTypeId) {
                if (ruleTypeId === 'anomaly') {
                    return {
                        'alert': {
                            description: '',
                            default: true
                        }
                    };
                }
                if (ruleTypeId === 'access_control') {
                    return {
                        'block': { default: true },
                        'alert': {}
                    };
                }
                if (ruleTypeId === 'clicktime_protection') {
                    return { 'inline': { default: true } };
                }
                if (policyRuleConfig.getSaasType(saas) === 'email') {
                    if (ruleTypeId === 'dlp') {
                        var rules = {
                            'alert': {
                                description: 'Emails to users outside organization are sent as always.<br />' + 'DLP detections are reported via security events and email',
                                default: true
                            }
                        };
                        if (feature.inlineDLP && !inlineDlpBlacklist.includes(saas)) {
                            rules.inline = { description: 'Emails are scanned by DLP before allowed out.<br />' + 'Emails containing leak are rejected,<br />' + 'workflow takes place.' };
                        }
                        return rules;
                    } else {
                        if (feature.checkpointTheme) {
                            return {
                                'inline': { description: '<strong>The system inspects all emails and attachments <br/>before delivery to users.</strong><br/>' + ' Malicious items are blocked before reaching users.' },
                                'normal': { description: '<strong>The system monitors emails to detect and <br/>logs malicious events.</strong><br/>' + 'Emails are scanned after delivery to users. <br/>' + 'Remediation action is automatically taken <br/>' + 'in case a malicious email is detected.' },
                                'alert': {
                                    description: '<strong>The system monitors emails to detect and <br/>log malicious events.</strong><br/>' + 'No remediation action is automatically taken <br/>' + 'in case a malicious email is detected.',
                                    default: true
                                }
                            };
                        }
                        return {
                            'inline': { description: '<strong>Users receive the emails only after found clean</strong> by security apps.<br />' + 'Malicious emails are quarantined automatically.<br />' + 'Scanning can sometime take up to a few minutes.' },
                            'normal': { description: '<strong>Users receive the emails immediately.</strong><br />' + 'Malicious emails are removed from the inbox (quarantined).<br />' + 'User is alerted about phishing attempts.<br />' + 'Scanning can take up to a few minutes.' },
                            'alert': {
                                description: '<strong>Users receive emails immediately</strong>. No actions.<br />' + 'Security events are reported by the system.',
                                default: true
                            }
                        };
                    }
                } else {
                    if (ruleTypeId === 'dlp') {
                        return {
                            'normal': { description: 'Files are scanned by activated DLPs as soon as those are added to drive.<br />' + 'In case of a leak remediation actions take place' },
                            'alert': {
                                description: 'Files are shared without interruptions.<br />' + 'No remediation actions take place.<br />' + 'In case of a leak, a security event will be generated.',
                                default: true
                            }
                        };
                    } else {
                        if (feature.checkpointTheme) {
                            return {
                                'normal': { description: 'The system monitors emails to detect and log malicious events.<br/>' + 'Files are scanned after upload to drive. Remediation action <br/>' + 'is automatically taken in case a malicious file is detected.' },
                                'alert': {
                                    description: 'The system monitors files to detect and log malicious events.<br/>' + 'No action is automatically taken by the system <br/>' + 'in case a malicious file is detected.',
                                    default: true
                                }
                            };
                        }
                        return {
                            'normal': { description: 'Files are scanned after being added to the drive.<br />' + 'Remediation takes place once malware is detected.<br />' + 'This could take a few minutes.' },
                            'alert': {
                                description: 'Malicious files stay in drive.<br />' + 'Alerts are generated upon detection.',
                                default: true
                            }
                        };
                    }
                }
            }
        };
        return policyRuleConfig;
    }]);
}());